import HeatingValueTable from "./components/HeatingValueTable";

const SetupHeatingValue = () => {
  return <HeatingValueTable />;
};

export default SetupHeatingValue;
